import { render, staticRenderFns } from "./chemProcessKnowhowDetail_old.vue?vue&type=template&id=37c04f5b"
import script from "./chemProcessKnowhowDetail_old.vue?vue&type=script&lang=js"
export * from "./chemProcessKnowhowDetail_old.vue?vue&type=script&lang=js"
import style0 from "./chemProcessKnowhowDetail_old.vue?vue&type=style&index=0&id=37c04f5b&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c04f5b')) {
      api.createRecord('37c04f5b', component.options)
    } else {
      api.reload('37c04f5b', component.options)
    }
    module.hot.accept("./chemProcessKnowhowDetail_old.vue?vue&type=template&id=37c04f5b", function () {
      api.rerender('37c04f5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/msds/chemProcessKnowhowDetail_old.vue"
export default component.exports